import influencerReducer from './influencer.slice'

export default influencerReducer
